import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/695a9e937683ed0014254bad/gullklar_landing_page/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/695a9e937683ed0014254bad/gullklar_landing_page/src/app/landing-page/components/FooterSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/695a9e937683ed0014254bad/gullklar_landing_page/src/components/ui/AppIcon.tsx");
